import { Creator } from "@nens/rana/api-v1";
import { RanaLoading, SystemStatusPage } from "@nens/ranalib";

import { PUBLICATION_SEARCH_KEY } from "@/config/query-parameter-consts";
import { usePublicationQuery } from "@/queries/query-publication";

import { PublicationPublicAccountModal } from "./components/public-account-modal";

type PublicationPublicGateProps = {
  setPublicUser: (publicUser: Creator) => void;
  initialUser?: { givenName: string; familyName: string; email: string };
  onClose?: () => void;
};

/**
 * Gate component for the shared publication entry flow. Fetches the publication,
 * handles loading and invalid/expired link states, then renders the account modal.
 * Used when we don't yet know whether the link is valid (i.e. before auth is set up).
 */
export function PublicationPublicGate({
  setPublicUser,
  initialUser,
  onClose,
}: PublicationPublicGateProps) {
  const publicationId = new URLSearchParams(window.location.search).get(PUBLICATION_SEARCH_KEY);
  const { data: publication, isLoading, isError } = usePublicationQuery(publicationId ?? undefined);

  if (isLoading) return <RanaLoading isCentered />;
  if (!publicationId || isError || !publication)
    return <SystemStatusPage variant="no-publication-found" />;

  return (
    <PublicationPublicAccountModal
      publication={publication}
      publicationId={publicationId}
      setPublicUser={setPublicUser}
      initialUser={initialUser}
      onClose={onClose}
    />
  );
}
